import { getAdminAudienceEditPathsV2 } from "@circle-react/helpers/urlHelpers/adminMemberEditPaths";

import { t } from "@/i18n-js/instance";
import { getChatRoomUrlWithMessageId } from "@/react/components/Chat/ChatWindowV2/helpers/helper2";
import type { FlaggedContent } from "@/react/types/FlaggedContent";
import {
  CHAT_ROOM_MESSAGE_TYPE,
  CONNECT_CONNECTION_TYPE,
} from "@/react/types/FlaggedContent";

import { getTimeAgo } from "../../utils";

const i18nRoot = "settings.moderation.review_flagged_content_modal";

export const getReportHeaderData = (flaggedContent: FlaggedContent) => {
  const { author, flagged_contentable } = flaggedContent;

  const {
    id: flaggedContentableId,
    initiator,
    post_slug: postSlug,
    recipient,
    slug,
    space,
    title: postTitle,
    type,
    is_embedded: isEmbeddedChat,
    parent_message_id: parentMessageId,
  } = flagged_contentable ?? {};

  const isConnection = type === CONNECT_CONNECTION_TYPE;
  const communityMember = isConnection ? initiator : author;

  const {
    avatar_url: avatarUrl,
    name: memberName,
    sqid,
  } = communityMember ?? {};
  const { slug: spaceSlug, name: spaceName } = space ?? {};
  const recipientName = recipient?.name;
  const recipientSqid = recipient?.sqid;

  const spaceUrl = `/c/${spaceSlug}`;
  const postUrl =
    type === CHAT_ROOM_MESSAGE_TYPE
      ? spaceUrl
      : `${spaceUrl}/${postSlug || slug}`;
  const chatMessageUrl =
    type === CHAT_ROOM_MESSAGE_TYPE &&
    flaggedContentableId &&
    Boolean(isEmbeddedChat) &&
    spaceSlug
      ? getChatRoomUrlWithMessageId(
          { slug: spaceSlug, uuid: "" },
          {
            id: flaggedContentableId,
            parent_message_id: parentMessageId ?? null,
            embedded: Boolean(isEmbeddedChat),
          },
        )
      : null;
  const paths = getAdminAudienceEditPathsV2({ sqid });
  const communityMemberUrl = paths.info;
  const recipientUrl = recipientSqid
    ? getAdminAudienceEditPathsV2({ sqid: recipientSqid }).info
    : undefined;

  return {
    avatarUrl,
    chatMessageUrl,
    communityMember,
    communityMemberUrl,
    flaggedContentableId,
    memberName,
    postTitle,
    postUrl,
    recipientName,
    recipientUrl,
    spaceName,
    spaceUrl,
  };
};

export const getStatusText = (flaggedContent: FlaggedContent) => {
  const { reported_at: reportedAt = "", reporter, status } = flaggedContent;
  const type = flaggedContent.flagged_contentable?.type;
  const isConnection = type === CONNECT_CONNECTION_TYPE;
  const reporterName = reporter?.name;

  if (!reporter) {
    return t([i18nRoot, "auto_flagged"]);
  }
  if (isConnection && reporterName) {
    return t([i18nRoot, "reported_by"], { name: reporterName });
  }
  if (status === "pending") {
    return t([i18nRoot, "awaiting_moderation"]);
  }
  return t([i18nRoot, "reported"], { time: getTimeAgo(reportedAt) });
};
